import { __extends } from "tslib";
import { PureComponent } from 'react';
import * as ReactDOM from 'react-dom';
import ready from './ready';
var deprecationWarningSent = false;
var PortalCreator = /** @class */ (function (_super) {
    __extends(PortalCreator, _super);
    function PortalCreator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selfHosted = false;
        _this.element = null;
        return _this;
    }
    PortalCreator.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, createPortal = _a.createPortal, children = _a.children;
        this.element = createPortal(children);
        if (this.element)
            return;
        this.selfHosted = true;
        if (!deprecationWarningSent) {
            deprecationWarningSent = true;
            // eslint-disable-next-line no-console
            console.warn('Использование порталов без изолированного контекста скоро перестанет поддерживаться. Оберните приложение в PortalProvider.');
        }
        this.element = document.createElement('div');
        ready(function () {
            document.body.appendChild(_this.element);
        });
    };
    PortalCreator.prototype.componentDidUpdate = function () {
        if (this.selfHosted)
            return;
        var _a = this.props, updatePortal = _a.updatePortal, children = _a.children;
        updatePortal(this.element, children);
    };
    PortalCreator.prototype.componentWillUnmount = function () {
        if (!this.selfHosted) {
            var destroyPortal = this.props.destroyPortal;
            return destroyPortal(this.element);
        }
        return document.body.removeChild(this.element);
    };
    PortalCreator.prototype.render = function () {
        var children = this.props.children;
        if (this.selfHosted) {
            return ReactDOM.createPortal(children, this.element);
        }
        return null;
    };
    PortalCreator.defaultProps = {
        children: []
    };
    return PortalCreator;
}(PureComponent));
export default PortalCreator;
//# sourceMappingURL=PortalCreator.js.map